<template>
	<picture>
		<source
			v-for="source in src"
			v-bind="source"
			:type="getImageType(source.srcset)"
		>
		<img :src="img" :alt="alt">
	</picture>
</template>

<script setup>

const props = defineProps({
	src: {
		type: Array,
		required: true,
	},
	alt: {
		type: String,
	},
	img: {
		type: String,
		default: function(prop) {
			const { src, srcset } = prop.src.pop() // pega o ultimo

			return src || srcset
		}
	}
})
const imageTypes = [
	{
		ext: /\.apng$/,
		type: 'image/apng'
	},
	{
		ext: /\.avif$/,
		type: 'image/avif'
	},
	{
		ext: /\.gif$/,
		type: 'image/gif'
	},
	{
		ext: /\.(jpg|jpeg|jfif|pjpeg|pjp)$/,
		type: 'image/jpeg'
	},
	{
		ext: /\.png$/,
		type: 'image/png'
	},
	{
		ext: /\.svg$/,
		type: 'image/svg+xml'
	},
	{
		ext: /\.webp$/,
		type: 'image/webp'
	},
]
const getImageType = url => {
	let fileType = 'image/png'

	imageTypes.forEach(format => {
		if (format.ext.test(url)) {
			fileType = format.type
		}
	})

	return fileType
}
</script>
